import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "default-quote",
  "use": "default-quote-usage",
  "viewBox": "0 0 46 46",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 46 46\" id=\"default-quote\"><path d=\"M15.978 14.347c0 7.6-.922 13.683-2.021 17.483-1.099 3.8-3.033 8.434-5.43 13.158l-6.429-4.4c3.197-6.265 4.926-12.68 5.326-17.61l-6.41-.033L1 .993l15-.005-.022 13.36zm29 0c0 7.6-.922 13.683-2.021 17.483-1.099 3.8-3.033 8.434-5.43 13.158l-6.429-4.4c3.197-6.265 4.926-12.68 5.326-17.61l-6.41-.033L30 .993l15-.005-.022 13.36z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol